import React from "react";

const TransformationMain = () => {
    return (
        <div>
            <div className="">
                {/* LEFT DIV ******* */}

                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div>
                        <table class="table text-left table-bordered">
                            <thead
                                className="text-dark text-center"
                                style={{
                                    background: "#F5C4AF",
                                    border: "2px solid black",
                                }}
                            >
                                <tr>
                                    <th scope="col" style={{ width: "12%" }}>
                                        Project Name
                                    </th>
                                    <th
                                        // colSpan={2}
                                        className="text-center"
                                        scope="col"
                                        style={{ width: "50%" }}
                                    >
                                        Project Description
                                    </th>
                                    <th
                                        // colSpan={2}
                                        className="text-center"
                                        scope="col"
                                        style={{ width: "16%" }}
                                    >
                                        Project Area
                                    </th>
                                    <th
                                        // colSpan={2}
                                        className="text-center"
                                        scope="col"
                                        style={{ width: "16%" }}
                                    >
                                        Toolkit link
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        scope="row"
                                        className=" m-2"
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                        }}
                                    >
                                        Lorem ipsum dolor sit
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        scope="row"
                                        className=" m-2"
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                        }}
                                    >
                                        Lorem ipsum dolor sit
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        scope="row"
                                        className=" m-2"
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                        }}
                                    >
                                        Lorem ipsum dolor sit
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet Lorem
                                        ipsum, dolor sit amet consectetur
                                        adipisicing elit. In provident ex odio.
                                        Error at commodi asperiores dolores quo
                                        dolor porro.
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        scope="row"
                                        className=" m-2"
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                        }}
                                    >
                                        Lorem ipsum dolor sit
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet Lorem
                                        ipsum, dolor sit amet consectetur
                                        adipisicing elit. In provident ex odio.
                                        Error at commodi asperiores dolores quo
                                        dolor porro.
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        scope="row"
                                        className=" m-2"
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                        }}
                                    >
                                        Lorem ipsum dolor sit
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet Lorem
                                        ipsum, dolor sit amet consectetur
                                        adipisicing elit. In provident ex odio.
                                        Error at commodi asperiores dolores quo
                                        dolor porro.
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransformationMain;
